@switch (mode) { @case (LabelMode.DEFAULT) {
<ng-container [ngTemplateOutlet]="default"></ng-container>
} @case (LabelMode.INLINE) {
<ng-container [ngTemplateOutlet]="inline"></ng-container>
} @case (LabelMode.NO_LABEL) {
<ng-container [ngTemplateOutlet]="nolabel"></ng-container>
} }

<ng-template #input>
  @if (mask) {
  <!-- Theme input -->
  <input
    class="form-control {{ inputClass }}"
    [ngClass]="{
      'is-invalid': isError,
      'is-valid': isValid,
      'bg-img-none': type === 'password' && isError
    }"
    [type]="type"
    [id]="name"
    [name]="name"
    [placeholder]="placeholder | translate"
    [formControl]="form"
    [tabindex]="tabindex"
    [mask]="mask"
    [prefix]="maskPrefix"
    [dropSpecialCharacters]="dropSpecialCharacters"
    [thousandSeparator]="thousandSeparator"
    [allowNegativeNumbers]="allowNegativeNumbers"
    [minlength]="minlength"
    [maxlength]="maxlength"
    (input)="onInputChange($event)"
    [readOnly]="readonly"
  />
  <!-- Default input -->
  <!-- <input
    class="form-control {{ inputClass }}"
    [ngClass]="{ 'is-invalid': isError, 'is-valid': isValid }"
    [type]="type"
    [id]="name"
    [name]="name"
    [placeholder]="placeholder | translate"
    [formControl]="form"
    [tabindex]="tabindex"
    [mask]="mask"
    [prefix]="maskPrefix"
    [dropSpecialCharacters]="dropSpecialCharacters"
    [thousandSeparator]="thousandSeparator"
    [specialCharacters]="specialCharacters"
    [minlength]="minlength"
    [maxlength]="maxlength"
    /> -->
  } @if (!mask) {
  <!-- Theme input -->
  <input
    class="form-control   {{ inputClass }}"
    [ngClass]="{
      'is-invalid': isError,
      'is-valid': isValid,
      'bg-img-none': type === 'password' && isError
    }"
    [type]="type === 'password' ? (showPwd ? 'text' : 'password') : type"
    [id]="name"
    [name]="name"
    [placeholder]="placeholder | translate"
    [formControl]="form"
    [tabindex]="tabindex"
    [autocomplete]="autocomplete"
    [min]="minVal"
    [max]="maxVal"
    (input)="onInputChange($event)"
    [readOnly]="readonly"
  />
  <!-- Default input -->
  <!-- <input
    class="form-control {{ inputClass }}"
    [ngClass]="{ 'is-invalid': isError, 'is-valid': isValid }"
    [type]="type === 'password' ? (showPwd ? 'text' : 'password') : type"
    [id]="name"
    [name]="name"
    [placeholder]="placeholder | translate"
    [formControl]="form"
    [tabindex]="tabindex"
    [autocomplete]="autocomplete"
    [min]="minVal"
    [max]="maxVal"
    /> -->
  @if (type === 'password') {
  <ng-container [ngTemplateOutlet]="passwordView"></ng-container>
  } }
</ng-template>

<ng-template #nolabel>
  <div class="input-group input-group-merge">
    <ng-container [ngTemplateOutlet]="input"></ng-container>
    @if (suffix) {
    <ng-container [ngTemplateOutlet]="inputSuffix"></ng-container>
    }
  </div>
  <ng-container [ngTemplateOutlet]="error"></ng-container>
</ng-template>

<ng-template #default>
  <div class="form-group" [ngClass]="classes">
    <ng-container [ngTemplateOutlet]="mainLabel"></ng-container>
    <div
      class="input-group input-group-merge"
      [ngClass]="{ disabled: form.disabled }"
    >
      <ng-container [ngTemplateOutlet]="input"></ng-container>
      @if (suffix) {
      <ng-container [ngTemplateOutlet]="inputSuffix"></ng-container>
      }
    </div>
    <ng-container [ngTemplateOutlet]="error"></ng-container>
  </div>
</ng-template>

<ng-template #inline>
  <div class="form-group form-group-inline" [ngClass]="classes">
    <ng-container [ngTemplateOutlet]="mainLabel"></ng-container>
    <ng-container [ngTemplateOutlet]="input"></ng-container>
    <ng-container [ngTemplateOutlet]="error"></ng-container>
  </div>
</ng-template>

<ng-template #mainLabel>
  @if (labelValue) {
  <label
    [for]="name"
    class="col-form-label fw-semibold fs-6 py-2"
    [ngClass]="required ? 'required' : ''"
    >{{ label | translate : { no: labelValue } }}
    <ng-container [ngTemplateOutlet]="subLabel"></ng-container
  ></label>
  } @if (!labelValue) {
  <label
    [for]="name"
    class="col-form-label fw-semibold fs-6 py-2"
    [ngClass]="required ? 'required' : ''"
    >{{ label | translate }}
    <ng-container [ngTemplateOutlet]="subLabel"></ng-container
  ></label>
  }
</ng-template>

<ng-template #subLabel>
  @if (addonLabel !== '' && addonLabel !== '*') {
  <span class="text-danger">({{ addonLabel | translate }})</span>
  } @if (addonLabel !== '' && addonLabel === '*') {
  <span class="text-danger">{{ addonLabel | translate }}</span>
  }
</ng-template>

<ng-template #inputSuffix>
  <div class="input-group-append">
    <span
      class="input-group-text text-muted font-th-data"
      [ngClass]="{ 'is-invalid': isError, 'is-valid': isValid }"
      >{{ suffix | translate }}</span
    >
  </div>
</ng-template>

<ng-template #error>
  @if (isError && showErrorMessage) {
  <span class="error text-danger">{{ errorMessage | translate }}</span>
  }
</ng-template>

<ng-template #passwordView>
  <div
    class="input-group-append"
    role="button"
    tabindex="0"
    (click)="showPwd = !showPwd"
    (keydown.enter)="showPwd = !showPwd"
    (keydown.space)="showPwd = !showPwd; $event.preventDefault()"
  >
    <span
      class="input-group-text cursor-pointer input-button-merge-left bg-transparent border-start-0 show-pwd"
      [ngClass]="{ 'is-invalid': isError, 'is-valid': isValid }"
    >
      <app-keenicon
        [name]="showPwd ? 'eye-slash' : 'eye'"
        class="fs-1 svg-icon svg-icon-2 cursor-pointer"
      ></app-keenicon>
    </span>
  </div>
</ng-template>
